import LinkedAccountDetailTemplate from '@/features/agent/linked_accounts/templates/LinkedAccountDetailTemplate';
import { createFileRoute } from '@tanstack/react-router';

type LinkedAccountDetailSearch = { from?: 'shared' };

export const Route = createFileRoute('/agent/linked_accounts/$id')({
  component: LinkedAccountDetail,
  staticData: { title: '連携先詳細' },
  validateSearch: (search: Record<string, unknown>): LinkedAccountDetailSearch => ({
    from: search.from === 'shared' ? 'shared' : undefined,
  }),
});

function LinkedAccountDetail() {
  const { id } = Route.useParams();
  const { from } = Route.useSearch();

  return <LinkedAccountDetailTemplate id={Number(id)} from={from} />;
}
